module.exports = __webpack_public_path__ + "static/assets/06a18a97538849d8c770e421eede6dc2.png";